import React from 'react';

import {
  Container,
} from '@uncinc/uncinc-react-kitchen-sink';

import './style.scss';

function setDangerousHtml(html, el) {
  if (el === null) return;
  const range = document.createRange();
  range.selectNodeContents(el);
  range.deleteContents();
  el.appendChild(range.createContextualFragment(html));
}
const ParagraphCustomHtml = ({ id, entity }) => {
  const body = entity.getIn(['field_body', 0, 'value']);

  return (
    <Container id={id} className="Paragraph ParagraphCustomHtml">
      <div className="row">
        <div className="ParagraphCustomHtml__inner col-12">
          <div ref={setDangerousHtml.bind(null, body)} />
        </div>
      </div>
    </Container>
  );
};

export default ParagraphCustomHtml;
